import { useSuspenseQuery, } from '@tanstack/react-query';
import { fetchFeatures, getFeature } from './client';
/**
 * Create a query key for features
 */
function createFeatureQueryKey(mainAccountId, token, impersonateId) {
    return ['features', mainAccountId, token, impersonateId].filter(Boolean);
}
/**
 * Hook to fetch all features for a main account
 */
export function useAllFeatures(mainAccountId, options = {}) {
    const { token, impersonateId } = options;
    const query = useSuspenseQuery({
        queryKey: createFeatureQueryKey(mainAccountId, token, impersonateId),
        queryFn: () => fetchFeatures(mainAccountId, { token, impersonateId }),
        // Cache for 5 minutes
        staleTime: 5 * 60 * 1000,
    });
    return {
        data: query.data || {},
        isFetched: query.isFetched,
        isLoading: query.isLoading,
        error: query.error,
    };
}
/**
 * Hook to get a specific feature by name
 */
export function useFeature(featureName, mainAccountId, options = {}) {
    const { data: features, isFetched, isLoading, error, } = useAllFeatures(mainAccountId, options);
    const { isFeatureEnabled, variables, variationKey, source } = getFeature(features, featureName);
    return {
        isFeatureEnabled,
        variables,
        variationKey,
        source,
        isFetched,
        isLoading,
        error,
    };
}
/**
 * Server-side query options for features
 */
export function createAllFeaturesQueryOptions(mainAccountId, options = {}) {
    const { token, impersonateId } = options;
    return {
        queryKey: createFeatureQueryKey(mainAccountId, token, impersonateId),
        queryFn: () => fetchFeatures(mainAccountId, { token, impersonateId }),
        staleTime: 5 * 60 * 1000,
    };
}
//# sourceMappingURL=hooks.js.map